import { Component, OnInit, Inject } from '@angular/core';
import { Etapa } from 'src/app/models/etapa';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { TemplateEmail } from 'src/app/models/template-email';
import { TemplateEmailService } from 'src/app/services/template-email.service';

@Component({
  selector: 'app-cadastrar-etapa',
  templateUrl: './cadastrar-etapa.component.html',
  styleUrls: ['./cadastrar-etapa.component.scss']
})
export class CadastrarEtapaComponent implements OnInit {

  etapa: Etapa;
  templates: TemplateEmail[] = [];
  public config: PerfectScrollbarConfigInterface = {};

  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarEtapaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private templateEmailService: TemplateEmailService) { }

  ngOnInit() {
    this.buscarTemplates();
    this.etapa = this.data.etapa;
  }

  buscarTemplates() {
    this.carregandoService.mostra('buscarTemplates');

    this.templateEmailService.consultarTemplates().subscribe(dados => {
      this.templates = dados;
      this.carregandoService.esconde('buscarTemplates');
    }, (erro) => {
      this.carregandoService.esconde('buscarTemplates');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.dialogRef.close(this.etapa);
  }

  fechar() {
    this.dialogRef.close();
  }
}